import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="p-6 bg-red-900/90 text-white rounded-lg border border-red-500 shadow-2xl m-4">
                    <h2 className="text-2xl font-bold mb-4">⚠️ Er is iets fout gegaan</h2>
                    <p className="mb-4">De applicatie is vastgelopen. Hier is de technische foutmelding:</p>
                    <div className="bg-black/50 p-4 rounded font-mono text-xs overflow-auto max-h-64 mb-4">
                        <p className="text-red-300 font-bold">{this.state.error && this.state.error.toString()}</p>
                        <pre className="text-slate-400 mt-2">{this.state.errorInfo && this.state.errorInfo.componentStack}</pre>
                    </div>
                    <button
                        onClick={() => window.location.reload()}
                        className="btn btn-primary bg-white text-red-900 hover:bg-slate-200"
                    >
                        Pagina Verversen
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
